import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DiscoverComponent } from '../Core/components/Discover/discover.component';
import { DiscoverRoutingService } from './services/discover-routing.service';

import { DiscoverActivateGuard } from './guards/discover-activate.guard';
import { TargetingSearchDeactivateGuard } from './guards/targeting-search-deactivate.guard';

import { DistributionDeactivateGuard } from '../DiscoverRouter/guards/distribution-deactivate.guard';
import { InfluencerStreamsActivateGuard } from './guards/influencer-streams-activate.guard';

import { targetingSearchRoutes } from './routes/targeting-search.routes';
import { targetingListRoutes } from './routes/targeting-list.routes';
import { portfolioRoutes } from './routes/portfolio.routes';
import { privateContactRoutes } from './routes/private-contact.routes';
import { distributionRoutes } from './routes/distribution.routes';
import { profileRoutes } from './routes/profile.routes';
import { influencerStreamRoutes } from './routes/influencer-stream.routes';

const discoverRoutes: Routes = [
    {
        path: 'Discover',
        canActivate: [DiscoverActivateGuard],
        component: DiscoverComponent,
        children: [
            { path: 'targetingsearches',       children: targetingSearchRoutes },
            { path: 'targetinglists',          children: targetingListRoutes   },
            { path: 'portfolios',              children: portfolioRoutes       },
            { path: 'privatecontacts',         children: privateContactRoutes  },
            { path: 'distributions',           children: distributionRoutes    },
            { path: 'profile',                 children: profileRoutes         },
            { path: 'influencerstreams',       children: influencerStreamRoutes, canActivate : [InfluencerStreamsActivateGuard] },
            { path: '**', redirectTo: '/Discover/targetingsearches' }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(discoverRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        DiscoverRoutingService,
        DiscoverActivateGuard,
        TargetingSearchDeactivateGuard,
        DistributionDeactivateGuard,
        InfluencerStreamsActivateGuard
    ]
})
export class DiscoverRoutingModule { }
